import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { fb } from '../../../../../shared/shared.global-service';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    SERVICE_RISK_TYPE_DEFAULT,
    SERVICE_RISK_TYPE_KEY,
    ServiceSettingsRiskTypeType,
} from '@libs/types/src/services/types/service-settings-risk-type.type';
import { ServiceSettingsRiskTypeStore } from './service-settings-risk-type.store';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { ActivatedRoute } from '@angular/router';
import { ServiceSettingsUpdateInput } from '@libs/types/src/services/input-type/services/service-settings.update-input';
import { contentGlobalSuccess } from '../../../../content.error';
import { CardComponent } from '../../../../../../components/kit/card/card.component';
import { InputText } from '@openng/optimus-ui/inputtext';
import { DeleteButtonComponent } from '../../../../../../components/kit/button/delete-button.component';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-risk-type',
    templateUrl: './service-settings-risk-type.component.html',
    styleUrl: './service-settings-risk-type.component.scss',
    providers: [ServiceSettingsRiskTypeStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardComponent,
        ReactiveFormsModule,
        InputText,
        DeleteButtonComponent,
        ButtonComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsRiskTypeComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceSettingsRiskTypeStore);
    private readonly route = inject(ActivatedRoute);

    riskTypesArray = fb.array<string>(SERVICE_RISK_TYPE_DEFAULT.riskTypes, Validators.required);
    form = fb.group({
        riskTypes: this.riskTypesArray,
    });

    private serviceId = 0;

    constructor() {
        super();
        this.subs.push(
            this.route.params.subscribe((params) => {
                this.serviceId = Number(params.serviceId || 0);
                if (this.serviceId) {
                    this.store.api.getServiceSettings(FilterBuilder.singlePage({
                        serviceId: this.serviceId,
                        key: SERVICE_RISK_TYPE_KEY,
                    })).then(() => this.setRiskTypes());
                }
            }),
        );

    }

    addRiskType() {
        const control = fb.control('', [Validators.required, Validators.minLength(1)]);
        this.riskTypesArray.push(control);
    }

    removeRiskType(index: number) {
        this.riskTypesArray.removeAt(index);
    }

    async save() {
        if (isInvalid(this.form)) {
            return;
        }
        const data = this.form.value as ServiceSettingsRiskTypeType;

        const settings: ServiceSettingsUpdateInput = {
            key: SERVICE_RISK_TYPE_KEY,
            data: JSON.stringify(data),
            serviceId: this.serviceId,
        };
        await this.store.api.updateServiceSettings(settings);
        contentGlobalSuccess.next('common.updated');
    }

    reset() {
        this.setRiskTypes();
    }

    private setRiskTypes() {
        if (!this.store.riskTypes().length) return;
        this.riskTypesArray.clear();
        this.store.riskTypes().forEach((types: string) => {
            const control = fb.control(types, [Validators.required]);
            this.riskTypesArray.push(control);
        });
    }
}
